function Nav() {

    document.addEventListener('DOMContentLoaded', function() {

        var $nav = $('.c-nav');
        var $body = $(document.body);
        var $triggers = $nav.find('.js-trigger');
        var $subTriggers = $nav.find('.js-sub-trigger');
        var $window = $(window);
        var $document = $(document);

        // amendment to popular links - now not a dropdown on mobile
        $subTriggers = $subTriggers.not(':eq(3)');

        $triggers.on('click', onTriggerClick);
        $subTriggers.on('click', toggleSubCategory);

        // Initialize nav as visible on page load
        $nav.addClass('is-showing');

        // Add scroll event listener for nav hide/show behavior
        $window.on('scroll', onScroll);

        PubSub.subscribe('app:breakpoint.change', function(msg, active) {
            var h = (active === 'phone') ? 0 : 'auto';
            $subTriggers.removeClass('is-open');
            $subTriggers.next().css('height', h);
        });

        PubSub.subscribe('close-nav', closeNav);
        PubSub.subscribe('page-dimmer:clicked', onPageDimmerClick);

        function onTriggerClick(e) {
            e.preventDefault();
            if ($(this).hasClass('is-open')) {
                closeNav();
            } else {
                // open
                $triggers.removeClass('is-open');
                $(this).addClass('is-open');
                $body.addClass('nav-open');
            }
        }

        function toggleSubCategory(e) {

            if (window.app.state.breakpoint !== 'phone') return;

            e.preventDefault();

            var $that = $(this);
            if ($that.hasClass('is-open')) {
                $that.removeClass('is-open');
                var $links = $that.next();
                $links.css('height', 0);
            } else {

                // close all subcategories
                $subTriggers.removeClass('is-open');
                $subTriggers.next().css('height', 0);

                // set height for css anim
                var $links = $that.next();
                $links.css('height', 'auto');
                var h = $links.height();
                $links.css('height', 0);
                $links.height(h);
                $that.addClass('is-open');

                // scroll to subcategory
                var $container = $that.parents('.c-nav__dest');
                $container.animate({
                    scrollTop: $that.parent().position().top
                });
            }
        }

        function onPageDimmerClick() {
            if ($body.hasClass('nav-open')) {
                closeNav();
            }
        }

        function closeNav() {
            $triggers.removeClass('is-open');
            $body.removeClass('nav-open');
        }

        //
        // sticky behaviour
        //

        var lastScrollTop = 0;
        var delta = 20;
        var navHeight = 64;
        
        function onScroll(e) {

            var scrollTop = $window.scrollTop();
            
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

            if (scrollTop > lastScrollTop && scrollTop > navHeight) {
                // scrolled down and past navbar -> hide
                $nav.removeClass('is-showing');
                $nav.addClass('is-hiding');
            } else {
                // scrolled up -> show
                if (scrollTop + $window.height() < $document.height()) {
                    $nav.removeClass('is-hiding');
                    $nav.addClass('is-showing');
                }
            }

            if (scrollTop > navHeight) {
                $nav.addClass('has-shadow');
            } else {
                $nav.removeClass('has-shadow');
            }

            lastScrollTop = scrollTop;
        }
    });
}


export default Nav;
